export function toCalendarControlFriendlyDate(date:Date):string {
    return date.toISOString().substring(0, 10);
}